import React from 'react';

type Props = {
  flags: { [flag: string]: boolean | null | undefined } | string[];
};

export const FeatureFlagContext = React.createContext<Props>({
  flags: []
});
